/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Growl } from 'primereact/growl'
import CompanyListComponent from '../components/CompanyListComponent'
import { companyActions } from '../_actions'

function CompanyListContainer({ companyList, getCompanyByPage, totalRecords, isCompanyLoading }) {
  const growl = useRef()
  return (<>
    <Growl ref={growl} />
    {isCompanyLoading && <div className="overlay">
      <div className="lds-ripple"><div></div><div></div></div>
    </div>}
    <div className="p-grid pageWrapper">
      <CompanyListComponent
        companyList={companyList}
        getCompanyByPage={getCompanyByPage}
        totalRecords={totalRecords}
        isCompanyLoading={isCompanyLoading} />
    </div>
  </>
  )
}
CompanyListContainer.propTypes = {
  companyList: PropTypes.array,
  getCompanyByPage: PropTypes.func,
  totalRecords: PropTypes.number,
  isGetAllError: PropTypes.bool,
  isPageLoad: PropTypes.bool,
  isCompanyLoading: PropTypes.bool,
}
const mapStateToProps = state => {
  return {
    companyList: state.company.companyList ? state.company.companyList : [],
    totalRecords: state.company.count,
    isGetAllError: state.company.isGetAllError,
    isPageLoad: state.company.isPageLoad,
    isCompanyLoading: state.company.isLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyByPage: (start, pageSize, search, type, typeId, sortBy) => dispatch(companyActions.getCompanyByPage(start, pageSize, search, type, typeId, sortBy)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyListContainer)
